<template>
  <div>
   <!-- <pre>{{filteredList}}</pre> -->
    <!-- {{select1}}
  {{selectLocation}}
  {{selectAreaMap}}
  {{selectHeightMap}}
  {{selectDevice}} -->
    <!-- <div  v-for="i in filteredList" :key="i">
    <pre>{{i.id}} {{i.height}}{{i.location}}</pre>
  </div> -->
    <vs-row vs-w="12">
      <vs-col style="text-align: center" vs-lg="6" vs-sm="12" vs-xs="12">
        <div class="img-wraps">
          <span
            style="width: 16%; height: 18%"
            :class="i.class"
            v-for="i in filteredList"
            :key="i"
          >
            <img
              v-if="i.type == select1"
              style="width: 100%; height: 100%"
              src="@/assets/icon/black.png"
            />
            <img
              v-if="select1 == 'Custom'"
              style="width: 100%; height: 100%"
              src="@/assets/icon/black.png"
            />
            <img
              v-if="select1 == 'Default'"
              style="width: 100%; height: 100%"
              src="@/assets/icon/black.png"
            />
          </span>
          <img
            class="imgMapFreacer"
            src="@/assets/images/frasers/Moon and Stairs Mystical Logo Template (4).png"
          />
        </div>
        <br /><br />
        <vs-row class="mb-1"><vs-spacer /> </vs-row>
        <vs-row v-if="['Inside'].includes(select1)"
          ><vs-spacer />
          <p class="mr-2" style="font-size: 0.85rem; color: rgba(0, 0, 0, 0.6)">
            Select Height :
          </p>
              <vs-radio v-model="btnHeigth" vs-name="radios7" class="mr-2" vs-value="">All</vs-radio>
          <vs-radio v-model="btnHeigth" vs-name="radios7" class="mr-2" vs-value="2m">2m</vs-radio>
          <vs-radio v-model="btnHeigth" vs-name="radios7" class="mr-2" vs-value="6m">6m</vs-radio>
          <vs-radio v-model="btnHeigth" vs-name="radios7" class="mr-2" vs-value="10m"
            >10m</vs-radio
          >
          <vs-radio v-model="btnHeigth" vs-name="radios7" class="mr-2" vs-value="12m"
            >12m</vs-radio
          >
          <!-- <div v-for="i in optionsHeight" :key="i">
            <vs-radio
              v-model="btnHeigth"
              class="mr-2"
              vs-name="radios1"
              @click="search(i.value)"
              :vs-value="i.value"
              >{{ i.text }}</vs-radio
            >
          </div> -->
          
          </vs-row
        >
      </vs-col>
      <vs-col class="mt-4" vs-type="flex" vs-lg="6" vs-sm="12" vs-xs="12">
        <div>
          <vs-select
            class="mb-4 mt-2"
            width="300px"
            label="Select Mode"
            v-model="select1"
          >
            <vs-select-item
              :key="index"
              :value="item.text"
              :text="item.text"
              v-for="(item, index) in optionsMap"
            />
          </vs-select>
          <vs-select
            v-if="['Custom'].includes(select1)"
            class="mb-4 mt-2"
            width="300px"
            multiple
            label="Select Location"
            v-model="selectLocation"
          >
            <vs-select-item
              :key="index"
              :value="item.text"
              :text="item.text"
              v-for="(item, index) in optionsMap2"
            />
          </vs-select>
          <vs-select
            v-if="
              ['Custom'].includes(select1) && selectLocation.includes('Outside')
            "
            class="mb-4 mt-2"
            width="300px"
            multiple
            label="Select Device Area"
            v-model="selectAreaMap"
          >
            <vs-select-item
              :key="index"
              :value="item.text"
              :text="item.text"
              v-for="(item, index) in optionsHeightOutside"
            />
          </vs-select>
          <vs-select
            v-if="
              ['Custom'].includes(select1) && selectLocation.includes('Inside')
            "
            class="mb-4 mt-2"
            width="300px"
            multiple
            label="Select Device Height"
            v-model="selectHeightMap"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in optionsHeight2"
            />
          </vs-select>
          <vs-select
            v-if="['Custom'].includes(select1)"
            width="300px"
            class="mb-4 mt-2"
            label="Select Device"
            label-placeholder="Multiple"
            multiple
            v-model="selectDevice"
          >
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.name"
              v-for="(item, index) in filterSelectDevice"
            />
          </vs-select>
           <a class="ml-2" style="font-size: 0.85rem; color: rgba(0, 0, 0, 0.6)"
            >Start Date</a
          >
          <datetime
            class="mb-4 mt-2"
            format="yyyy-MM-dd HH:mm:ss"
            v-model="startTime"
            type="datetime"
          />
          <a class="ml-2" style="font-size: 0.85rem; color: rgba(0, 0, 0, 0.6)"
            >End Date</a
          >
          <datetime
            format="yyyy-MM-dd HH:mm:ss"
            v-model="endTime"
            type="datetime"
          />
        </div>
      </vs-col>
    </vs-row>
    <br />
    <vs-row>
      <vs-spacer />
      <vs-button
        class="brdbtn mr-1"
        color="success"
        @click="checkFIlter(filteredList,startTime,endTime),  saveMapsetting(
              select1,
              selectHeightMap,
              selectDevice,
              selectAreaMap,
              selectLocation,
              filteredList,
              btnHeigth
            )"
        type="filled"
        >Submit</vs-button
      >
      <!-- <vs-button
          class="brdbtn mr-1"
          color="success"
          @click="
            saveMapsetting(
              optionsColor,
              select1,
              selectHeightMap,
              selectDevice,
              selectAreaMap,
              selectLocation,
              filteredList,
              btnHeigth
            )
          "
          type="filled"
          >Submit</vs-button
        > -->
      <vs-button
        class="brdbtn"
        color="dark"
        @click="closePopup3"
        type="flat"
        >Cancel</vs-button
      >
    </vs-row>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  name: "CustomDashboard",
  props: {
    iconMap: Array,
    propToGraph1: Function,
    closePopup3: Function,
    // select1: String,
    // selectHeightMap: Array,
    // selectDevice: Array,
    // selectLocation: Array,
    // selectAreaMap: Array,
    // btnHeigth: String,
  },
  data: () => ({
    testVariable: [],
    dataP: "",
     startTime: "",
    endTime: "",
    pages3: [{ text: "Page 1" }, { text: "Page 2" }, { text: "Page 3" }],
    popupActivo4: false,
    checkBox1: "",
    primeFilter: [],
    currentFilter: "",
    descriptionItems: [3, 5, 15],
    select1: "",
    selectLocation: [],
    selectHeightMap: [],
    selectAreaMap: [],
    selectDevice: [],
    btnHeigth: "",
    idDeviceList: [],
    device: [],
    optionsMap: [
      { text: "Default" },
      { text: "Inside" },
      { text: "Outside" },
      { text: "Custom" },
    ],
    optionsMap2: [{ text: "Inside" }, { text: "Outside" }],
    optionsHeight: [
      { text: "All", value: "" },
      { text: "2m", value: "2m" },
      { text: "6m", value: "6m" },
      { text: "10m", value: "10m" },
      { text: "12m", value: "12m" },
    ],
    optionsHeight2: [
      // { text: "All", value: "" },
      { text: "2m", value: "2m" },
      { text: "6m", value: "6m" },
      { text: "10m", value: "10m" },
      { text: "12m", value: "12m" },
    ],
    optionsHeightOutside: [{ text: "Left" }, { text: "Right" }],
    optionsID: [
      { text: "6 meters", value: "6m" },
      { text: "2 meters", value: "2m" },
    ],
    sensorList: [],
    iconMap: [],
    iconMapChart: [],
    fields: [
      { key: "date", label: "Timestamp", visible: true },
      { key: "id", label: "Device No.", visible: true },
      { key: "temperature", label: "Temperature (°C)", visible: true },
      { key: "humidity", label: "Humidity", visible: true },
      { key: "location", label: "Location", visible: true },
      { key: "height", label: "Height", visible: true },
      { key: "color", label: "Battery", visible: true },
    ],
    headerList: [
      { text: "Timestamp", visible: true },
      { text: "Device No.", visible: true },
      { text: "Temperature (°C)", visible: true },
      { text: "Humidity", visible: true },
      { text: "Location", visible: true },
      { text: "Hight", visible: true },
      { text: "Battery", visible: true },
    ],
    lo: [],
    arraylo: [],
    test: [],
    insidetem: 0,
    insidehum: 0,
    outsidetem: 0,
    outsidehum: 0,
    datetime: "",
    time: "",
    selectHeight: [],
    selectSide: [],
    optionsSide: [
      { text: "left", value: "left" },
      { text: "right", value: "right" },
    ],
    users: [],
    

    ////P
    headerchart: [],
    datachart: [],
    datachartout: [],
    datachart2: [],
    datachart2out: [],
    insidefiltem: 0,
    insidefilhum: 0,
    outidefiltem: 0,
    outidefilhum: 0,
    insidefil: 0,
    outsidefil: 0,
    inmin: 0,
    inmax: 0,
    outmin: 0,
    outmax: 0,
    a: [],
    users: [],
    groupedByHour: ([] = []),
  }),

  created() {
  },
  mounted() {
    this.$API.get(`dashboard/config/graph/6`).then((result) => {
      this.test = result.data;
      console.log(result.data);
      this.select1 = result.data[0].device_location;
      this.selectHeightMap = result.data[0].device_height;
      this.selectDevice = result.data[0].device;
      this.selectLocation = result.data[0].select_location;
      this.selectAreaMap = result.data[0].device_area_map;
      this.btnHeigth = result.data[0].height;
     this.startTime = result.data[0].start;
      this.endTime = result.data[0].end;
    });
  },
  methods: {
     checkFIlter(item,sd,ed) {
      var id = [];
      item.forEach((ss) => {
        id.push(ss.id);
      });
      var body = {
        device_id: id,
        start_date: sd,
        end_date: ed
      };
      this.propToGraph1(body);
    },
    search(btn) {
      let data = this.primeFilter.filter((element) => element.height == btn);
      this.btnHeigth = btn;
    },
    saveMapsetting(
      select,
      selectHeight,
      selectDevice,
      selectAreaMap,
      selectLocation,
      filteredList,
      selectHeigth2
    ) {
      var body = {
        deviceLocation: select,
        deviceHight: this.selectHeightMap,
        device: selectDevice,
        deviceAreaMap: selectAreaMap,
        selectLocation: selectLocation,
        selectHeigth: selectHeigth2,
        starttime: this.startTime,
        endtime: this.endTime
      };
      console.log(body);
      this.$API
        .put(`dashboard/config/graph/6`, body)
        .then((result) => {
          console.log(result.data);
          if (result.status == 200)
           this.closePopup3();
            this.$vs.notify({
              title: "Setting Updated",
              text: "Your setting has been updated",
              color: "primary",
              position: "top-center",
            });
          // setTimeout(() => {
          //   this.$refs["settingMap"].hide();
          //   this.popupActivo4 = false;
          //   location.reload();
          // }, 1500);
          setTimeout(() => {
            location.reload();
          }, 1500);
        })
        .catch((err) => {
          if (err.response.status == 500)
            this.$vs.notify({
              title: "Invalid",
              text: "Please try again",
              color: "warning",
              position: "top-center",
            });
        });
      // this.allsidefilter_avg(filteredListChart);
      // this.fetchChartfilter(filteredListChart);
      // location.reload();
    },
    calculateTemp(temp) {},
  },
  computed: {
    filteredList() {
      if (this.select1 == "Default") {
        return this.iconMap;
      } else if (this.select1 == "Custom") {
        if (
          this.selectLocation.length == 0 &&
          this.selectHeightMap.length == 0
        ) {
          this.primeFilter = this.iconMap;
        } else if (
          this.selectLocation.length == 0 &&
          this.selectHeightMap.length != 0
        ) {
          this.primeFilter = this.iconMap.filter((post) => {
            if (this.selectHeightMap.includes(post.height)) return post;
          });
        } else if (
          this.selectLocation.length != 0 &&
          this.selectHeightMap.length == 0
        ) {
          if (this.selectAreaMap.length == 0) {
            this.primeFilter = this.iconMap.filter((post) => {
              if (this.selectLocation.includes(post.type)) return post;
            });
          } else {
            this.primeFilter = this.iconMap
              .filter((post) => {
                if (this.selectLocation.includes(post.type)) return post;
              })
              .filter((post) => {
                if (this.selectAreaMap.includes(post.height)) return post;
              });
          }
        } else {
          if (this.selectLocation == "Inside") {
            let temp = this.iconMap
              .filter((post) => {
                if (this.selectLocation.includes(post.type)) return post;
              })
              .filter((post) => {
                if (this.selectHeightMap.includes(post.height)) return post;
              });
            this.primeFilter = temp;
            this.calculateTemp(this.primeFilter);
          } else if (this.selectLocation == "Outside") {
            let temp = this.iconMap
              .filter((post) => {
                if (this.selectLocation.includes(post.type)) return post;
              })
              .filter((post) => {
                if (this.selectAreaMap.includes(post.height)) return post;
              });
            this.primeFilter = temp;
            this.calculateTemp(this.primeFilter);
          } else {
            let tempArray = this.selectHeightMap.concat(this.selectAreaMap);
            let temp = this.iconMap
              .filter((post) => {
                if (this.selectLocation.includes(post.type)) return post;
              })
              .filter((post) => {
                if (tempArray.includes(post.height)) return post;
              });
            this.primeFilter = temp;
          }
        }
      } else {
        this.currentFilter = this.select1;
        this.primeFilter = this.iconMap.filter((post) => {
          return post.type
            .toString()
            .toLowerCase()
            .includes(this.select1.toLowerCase());
        });
        // ตรงนี้
        try {
          if (this.btnHeigth.length != 0 && this.select1 == "Inside")
            this.primeFilter = this.primeFilter.filter(
              (element) => element.height == this.btnHeigth
            );
          return this.primeFilter;
        } catch (error) {
          return this.primeFilter;
        }
      }

      if (this.selectDevice.length != 0) {
        let displayDevice = this.primeFilter.filter((post) => {
          if (this.selectDevice.includes(post.id)) return post;
        });
        displayDevice.forEach((element) => {
          let filteredData = displayDevice.filter(
            (data) => data.class == element.class
          );
          this.testVariable.push(filteredData);
          console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
          console.log(filteredData.length);
          filteredData.forEach((Fdata, Fi) => {
            if (Fi == 0) {
              // element.avgTemp = Fdata.temperature;
              element.selectLocationTemp =
                Fdata.name + " Temperature : " + Fdata.temperature + "°C \n";
              // element.avgHumd = Fdata.humidity;
            } else {
              // element.avgTemp = Fdata.temperature;
              element.selectLocationTemp +=
                Fdata.name + " Temperature : " + Fdata.temperature + "°C \n";
              // element.avgHumd = Fdata.humidity;
            }
          });
          element.avgTemp = (
            filteredData.reduce((total, next) => total + next.temperature, 0) /
            filteredData.length
          ).toFixed(1);
          element.avgHumd = (
            filteredData.reduce((total, next) => total + next.humidity, 0) /
            filteredData.length
          ).toFixed(1);
        });

        if (this.btnHeigth.length != 0 && this.select1 != "Custom")
          displayDevice = displayDevice.filter(
            (element) => element.height == this.btnHeigth
          );
        return displayDevice;
      } else if (this.selectDevice.length == 0) return this.primeFilter;
    },
    filterSelectDevice() {
      return this.primeFilter;
    },
    filterHeight() {
      this.primeFilter = this.primeFilter.filter((post) => {
        if (this.selectHeightMap.includes(post.height)) return post;
      });
      return this.primeFilter;
    },
  },
};
</script>
<style scoped>
.roundedCard {
  border-radius: 20px;
}
.vl {
  border-left: 2px solid rgb(197, 197, 197);
  height: 50;
}
.roundedCard {
  border-radius: 20px;
}
.imgMapFreacer {
  max-width: 70%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.brdbtn {
  width: 80px;
  border-radius: 20px;
}

.img-wraps {
  position: relative;
  display: inline-block;
}

.img-wraps .D3 {
  position: absolute;
  top: 65.5%;
  right: 3%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}

.img-wraps .D5 {
  position: absolute;
  top: 44.5%;
  right: 51.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .D6 {
  position: absolute;
  top: 48.5%;
  right: 62%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .B3 {
  position: absolute;
  top: 24.5%;
  right: 36%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .B4 {
  position: absolute;
  top: 24.5%;
  right: 31%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .B6 {
  position: absolute;
  top: 18.5%;
  right: 70%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .B5 {
  position: absolute;
  top: 34.5%;
  right: 62%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .B1 {
  position: absolute;
  top: 34.5%;
  right: 1%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F3 {
  position: absolute;
  top: 65.5%;
  right: 28%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F5 {
  position: absolute;
  top: 65.5%;
  right: 48.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F6 {
  position: absolute;
  top: 65.5%;
  right: 59.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
/* B7 */
.img-wraps .B7 {
  position: absolute;
  top: 6%;
  right: 61%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}

.img-wraps .J8 {
  position: absolute;
  top: 53.5%;
  right: 36%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .J14 {
  position: absolute;
  top: 53.5%;
  right: 12%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .G8 {
  position: absolute;
  top: 41.5%;
  right: 36%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .H3 {
  position: absolute;
  top: 48.5%;
  right: 57%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F3 {
  position: absolute;
  top: 34.5%;
  right: 57%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F14 {
  position: absolute;
  top: 34.5%;
  right: 12%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  /* font-size: 22px; */
  /* border-radius: 20px; */
  /* background: #ffffff; */
  line-height: 10px;
}
.img-wraps .L3 {
  position: absolute;
  top: 65.5%;
  right: 57%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .L8 {
  position: absolute;
  top: 65.5%;
  right: 36%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .L14 {
  position: absolute;
  top: 65.5%;
  right: 12%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .C3 {
  position: absolute;
  top: 18.5%;
  right: 57%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .C8 {
  position: absolute;
  top: 18.5%;
  right: 36%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .C14 {
  position: absolute;
  top: 18.5%;
  right: 12%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  /* font-size: 22px; */
  /* border-radius: 20px; */
  /* background: #ffffff; */
  line-height: 10px;
}
.img-wraps .A3 {
  position: absolute;
  top: 6%;
  right: 57%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .A6 {
  position: absolute;
  top: 6%;
  right: 45.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .A8 {
  position: absolute;
  top: 6%;
  right: 36%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .A11 {
  position: absolute;
  top: 6%;
  right: 22.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .A14 {
  position: absolute;
  top: 6%;
  right: 12%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .Left {
  position: absolute;
  top: 78%;
  right: 64%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .Right {
  position: absolute;
  top: -6%;
  right: 12%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  /* font-size: 22px; */
  /* border-radius: 20px; */
  /* background: #ffffff; */
  line-height: 10px;
}
.img-wraps .Outside {
  position: absolute;
  top: -7%;
  right: 12%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  /* font-size: 22px; */
  /* border-radius: 20px; */
  /* background: #ffffff; */
  line-height: 10px;
}
</style>